<template>
  <div>
    <b-row>
      <b-col cols="6" class="pr-0">
        <label>Keluhan<span class="text-danger" v-if="this.checkValueData(this.trx) && this.trx.kategori_id == 2">*</span></label>
        <div @click="asyncFindKeluhan('')">
          <multiselect
            v-model="selectedKeluhan"
            :options="optionKeluhan"
            :multiple="true"
            placeholder="Pilih Keluhan"
            label="description"
            track-by="description"
            :loading="isLoadingKeluhan"
            :hide-selected="true"
            :options-limit="10"
            :limit="10"
            open-direction="bottom"
            @search-change="debounceKeluhan($event)">
          </multiselect>
        </div>
      </b-col>
      <b-col cols="6" class="pr-0 mb-5" v-if="isKeluhanLainnya">
        <label>Keluhan Lainnya</label>
        <b-form-input
          type="text"
          v-model="keluhanLainnya"
          @input="updatePostData({key: 'keluhan_lainnya', value: $event})"
        />
      </b-col>

      <b-col :cols="isKeluhanLainnya ? 12 : 6" class="pr-0">
        <b-row>
          <b-col cols="12" class="row">
            <b-col cols="3" class="text-subtitle">
              <label>Anamnesa<span class="text-danger">*</span></label>
            </b-col>
            <b-col cols="9" class="float-right pen-isMobile">
              <div class="row d-flex justify-content-end mr-2">
                <div class="mt-2">
                  <span @click="penColor('blue');isColorActive = 'blue'" class="dot grow" style="background-color: blue;"
                    :class="{ color_active: isColorActive === 'blue' }"></span>
                  <span @click="penColor('red');isColorActive = 'red'" class="dot grow" style="background-color: red;"
                    :class="{ color_active: isColorActive === 'red' }"></span>
                  <span @click="penColor('#54c756');isColorActive = 'green'" class="dot grow"
                    style="background-color: #54c756;" :class="{ color_active: isColorActive === 'green' }"></span>
                  <span @click="penColor('#555');isColorActive = 'black'" class="dot grow" style="background-color: #555;"
                    :class="{ color_active: isColorActive === 'black' }"></span>
                  <span @click="penColor('orange');isColorActive = 'yellow'" class="dot grow"
                    style="background-color: orange;" :class="{ color_active: isColorActive === 'yellow' }"></span>
                </div>
                <font-awesome-icon
                  icon="eraser"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('eraser');"
                  v-show="!isHidden"
                  :class="{ active_tool: isActive === 'eraser' }" />
                <font-awesome-icon
                  icon="pen-alt"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('pen');"
                  :class="{ active_tool: isActive === 'pen' }" />
                <font-awesome-icon
                  icon="keyboard"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('keyboard');"
                    :class="{ active_tool: isActive === 'keyboard' }" />
              </div>
              <div class="row d-flex justify-content-end mr-2">
                <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidth" />
              </div>
            </b-col>
          </b-col>
          <b-col cols="12" id="anamnesa_canvas" v-show="!isHidden">
            <canvas
              id="anamnesa-canvas"
              ref="canvas"
              @mousedown="handleMousedown"
              @mouseup="handleMouseup"
              @mousemove="handleMousemove"
              @touchstart="handleTouchstart"
              @touchend="handleTouchend"
              @touchmove="handleTouchmove"
              :width="canvasWidth"
              :height="canvasHeight"
            >
              Your browser does not support the HTML 5 Canvas.
            </canvas>
          </b-col>
          <b-col cols="2" v-show="!isHidden">
            <b-button @click="clear" variant="warning" size="sm" class="m-1">Clear</b-button>
          </b-col>

          <b-col cols="12" id="editor_anamnesa" v-show="isHidden">
            <Editor
              :height="contentHeight"
              :width="contentWidth"
              class="form-anamnesa"
              :editorContent="anamnesa"
              v-on:update-content="updateContent"
            />
            <b-form-invalid-feedback class="text-lowercase" :state="anamnesaValidationStatus">
              {{ anamnesaValidationMessage }}
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" v-show="!isHidden">
            <div id="img_anamnesa"></div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6" class="pr-0" v-if="pasien.jenis_kelamin == '0'">
        <label for="is_pregnant">Apakah pasien sedang hamil?</label>
        <vue-select
          :options="option_pregnant_breastfeeding"
          v-model="isPregnant"
          class="__select-relative"
          @input="updateData('is_pregnant', $event)"
        >
        </vue-select>
      </b-col>
        <b-col cols="6" class="pr-0" v-if="pasien.jenis_kelamin == '0'">
          <label for="is_breastfeeding">Apakah pasien sedang menyusui?</label>
          <vue-select
            :options="option_pregnant_breastfeeding"
            v-model="isBreastfeeding"
            class="__select-relative"
            @input="updateData('is_breastfeeding', $event)"
          >
          </vue-select>
        </b-col>
    </b-row>
  </div>
</template>
  
<script>
  import debounce from 'lodash/debounce';
  import { mapGetters, mapActions, mapState } from 'vuex';
  
  export default {
    name: 'SubjectiveAnamnesa',
    components: {
      Multiselect: () => import('vue-multiselect'),
      Editor: () => import('./Editor.vue'),
      'vue-select': () => import('vue-select'),
    },
    data() {
      return {
        isDrawing: false,
        isHidden: true,
        isPen: false,
        isActive: 'keyboard',
        isColorActive: 'black',
        mousePos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        drawing: false,
        ctx: null,
        penWidth: 2,
        ediRekamMedis: {},
        anamnesa: null,
        imgAnamnesa: null,
        anamnesaValidationStatus: true,
        anamnesaValidationMessage: 'wajib diisi',
        contentWidth: 675,
        contentHeight: 155,
        canvasWidth: 675,
        canvasHeight: 180,
        option_pregnant_breastfeeding: [
          { label: 'Ya', value: 1 },
          { label: 'Tidak', value: 0 }
        ],
        isPregnant: null,
        isBreastfeeding: null,
        keywordKeluhan: '',
        keluhanLainnya: '',
        isLoadingKeluhan: false,
        isKeluhanLainnya: false,
        selectedKeluhan: [],
        optionKeluhan: [],
      };
    },
    computed: {
      ...mapState(['sidebar']),
      ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
      ...mapGetters(['pasien', 'getKlinikId', 'trx', 'canvas_anamnesa']),
      canvas() {
        return this.$refs.canvas;
      },
    },
    watch: {
      imgAnamnesa() {
        this.imgAnamnesaChanged();
      },
      pasien() {
        if (this.checkValueData(this.pasien)) {
          this.anamnesa = this.pasien.anamnesa || '';
          if (this.pasien.jenis_kelamin == '0') {
            this.isPregnant = this.option_pregnant_breastfeeding.find(pb => pb.value == this.pasien.is_pregnant);
            this.isBreastfeeding = this.option_pregnant_breastfeeding.find(pb => pb.value == this.pasien.is_breastfeeding);
          }
        }
      },
      anamnesaValidationStatus() {
        const editorAnamnesa = document.getElementById('editor_anamnesa');
        if (this.anamnesaValidationStatus) {
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.removeProperty('border-top');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.removeProperty('border-bottom');
        } else {
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-container')[0].style.setProperty('border-top', '1px solid #ccc');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border', '1px solid red');
          editorAnamnesa.getElementsByClassName('ql-toolbar')[0].style.setProperty('border-bottom', '1px solid #ccc');
        }
      },
      collapsed() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
        }, 500);
      },
      collapsedMobile() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
        }, 500);
      },
      orientation() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgAnamnesa = this.canvas_anamnesa ? this.canvas_anamnesa.toDataURL('image/png') : null;
        }, 500);
      },
      selectedKeluhan() {
        let lain = this.selectedKeluhan.find(k => k.description.toLowerCase().includes('lain'));
        this.isKeluhanLainnya = lain ? true : false;
        this.resizeWidth(this.collapsed);
        this.updatePostData({ key: 'keluhan', value: this.selectedKeluhan });
      },
      trx() {
        if (this.trx && this.trx.anamnesa_keluhan) {
          this.setAnamnesaKeluhan(this.trx.anamnesa_keluhan || []);
        }
      },
    },
    async mounted() {
      await this.resizeWidth(this.collapsed);

      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';
  
      //append data canvas to vuex global state
      this.updateCanvas({ key: 'ANAMNESA', value: this.canvas });
      this.updatePostData({ key: 'anamnesa_is_draw', value: false });
  
      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis')
      if (this.ediRekamMedis != null) this.setAnamnesaData(JSON.parse(this.ediRekamMedis));

      if (this.pasien) {
        if (this.pasien.jenis_kelamin == '0') {
          this.isPregnant = this.option_pregnant_breastfeeding.find(pb => pb.value == this.pasien.is_pregnant);
          this.isBreastfeeding = this.option_pregnant_breastfeeding.find(pb => pb.value == this.pasien.is_breastfeeding);
        }
      }

      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function(callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
  
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (e.target == document.getElementById('anamnesa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
    },
    methods: {
      ...mapActions(['updatePostData', 'updateCanvas', 'updatePasien']),
      resizeWidth(collapsed = false) {
        let elRM = document.getElementById('rekam_medis_klinik');

        let w = elRM.offsetWidth;
        let x = 1;

        if (this.isKeluhanLainnya) {
          if (w > 1400) x = 1.1;
          else if (collapsed) {
            if (this.orientation == 'portrait') x = 1.5;
            else {
              if (w < 1024) x = 1.3;
              else x = 1.15;
            }
          } else {
            if (this.orientation == 'portrait') x = 1.7;
            else {
              if (w < 750) x = 1.3;
              else if (w < 1024) x = 1.1;
              else x = 1.14;
            }
          }
        } else {
          if (w > 1400) x = 2.335;
          else if (collapsed) {
            if (this.orientation == 'portrait') x = 2.85;
            else {
              if (w < 1024) x = 2.9;
              else x = 2.55;
            }
          } else {
            if (this.orientation == 'portrait') x = 2.816;
            else {
              if (w < 750) x = 2.84;
              else if (w < 1024) x = 2.445;
              else x = 1.964;
            }
          }
        }

        this.canvasWidth = this.contentWidth = w / x;

        let height = this.canvasWidth * 0.5625;
        this.canvasHeight = height > 250 ? 250 : height;
        this.contentHeight = height > 250 ? 250 : (this.canvasHeight * 0.9);
      },
      // called if user using wysiwyg instead of drawing canvas
      updateData(key, $event) {
        let v = $event && typeof $event == 'object' ? $event.value : null;
        let p = {};
        p[key] = v;

        this.updatePostData({ key, value: v });
        this.updatePasien({ data: {...this.pasien, ...p} });
      },
      updateContent(content) {
        this.anamnesaValidationStatus = true;
        const kategori_id = this.checkValueData(this.trx) && this.trx.kategori_id;

        if (kategori_id == 2) {
          const strippedContent = content.replace(/<[^>]*>?/gm, '').trim();
    
          if (strippedContent.length == 0) {
            this.anamnesaValidationStatus = false;
            this.anamnesaValidationMessage = 'wajib diisi';
          }
          if (strippedContent.length < 10 || strippedContent.length > 255) {
            this.anamnesaValidationStatus = false;
            this.anamnesaValidationMessage = 'minimal 10 karakter, maksimal 255 karakter';
          }
        }
        
        this.updatePostData({ key: 'anamnesa_text', value: content });
        this.updatePasien({ data: {...this.pasien, anamnesa: content} });
      },
      setAnamnesaData(d) {
        if (d.anamnesa && d.anamnesa.is_draw) {
          this.anamnesa = d.anamnesa.notes;
          if (d.anamnesa.draw_path != null) {
            this.imgAnamnesa = d.anamnesa.draw_path;
            this.updatePostData({ key: 'anamnesa_is_draw', value: true });
          }
        } else {
          this.anamnesa = d.anamnesa ? d.anamnesa.notes : null;
        }

        this.setAnamnesaKeluhan(d.anamnesa_keluhan || []);
      },
      setAnamnesaKeluhan(d) {
        this.selectedKeluhan = d;
        let lainnya = this.selectedKeluhan.find(k => k.description.toLowerCase().includes('lain'));
        if (this.selectedKeluhan && lainnya) {
          this.isKeluhanLainnya = true;
          this.keluhanLainnya = lainnya.lainnya || '';
        }
      },
      imgAnamnesaChanged() {
        let self = this;
        self.image_url = self.imgAnamnesa;
        self.clear();
        self.drawBackground(self.image_url);
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('anamnesa-canvas'),
          ctx = canvas.getContext('2d'),
          img_anamnesa = document.getElementById('img_anamnesa');
        let backgroundURL = image_url;
  
        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;
  
        //remove existing image
        if (img_anamnesa.hasChildNodes()) {
          img_anamnesa.innerHTML = '';
        }
  
        background.onload = function() {
          let newSize = { width: self.canvasWidth, height: self.canvasHeight };
          ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          // pen drawing
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            // eraser
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      // Get the position of a touch relative to the canvas
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      // to change pen color
      penColor(color) {
        this.ispen = true;
        this.ctx.strokeStyle = color;
      },
      // to clear the canvas
      clear() {
        this.canvas.width = this.canvas.width;
        this.isDrawing = false;
        this.isColorActive = 'black';
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
        this.isActive = type;
        this.updatePostData({ key: 'anamnesa_is_draw', value: this.isDrawing });
      },
      // to get keluhan datas from backend
      debounceKeluhan: debounce(function(val) {
        this.keywordKeluhan = val;
        this.asyncFindKeluhan(val);
      }, 500),
      asyncFindKeluhan(query) {
        this.isLoadingKeluhan = true;

        let search = '';
        if (this.checkValueData(query)) {
          search = `?q=${query}`;
        }

        this.$axios.get(`keluhan${search}`)
        .then(response => {
          const { status, data } = response.data;

          if (!status) {
            this.isLoadingKeluhan = false;
            return;
          }
          
          this.optionKeluhan = data.data;
          this.isLoadingKeluhan = false;
        })
        .catch(err => {
          this.isLoadingKeluhan = false;
        });
      },
    },
  };
</script>
  
<style scoped>
  #anamnesa-canvas {
    touch-action: none;
  }
  .mb-10 {
    margin-bottom: 10rem !important;
  }
</style>

<style>
  .pen-width {
    width: 125px !important;
  }
  .form-anamnesa .quill-editor .ql-container.ql-snow .ql-editor.ql-blank::before {
    content: 'Tuliskan detail keluhan, contoh: demam 3 hari' !important;
  }
  #editor_anamnesa .form-anamnesa .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  #editor_anamnesa .form-anamnesa .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-anamnesa .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-anamnesa .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  @media screen and (max-width: 1400px) {
    .form-anamnesa .quill-editor .ql-toolbar {
      zoom: 70%;
    }
    .form-anamnesa .quill-editor .ql-container {
      color: #505050;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1024px) {
    .form-anamnesa .quill-editor .ql-toolbar {
      zoom: 60%;
    }
    .form-anamnesa .quill-editor .ql-container {
      color: #505050;
      font-size: 10px;
    }
  }
</style>